import React from 'react'
import { UrlApi } from '../../services/apirest'
import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";

function Choferbuscar({ value, onChange }) {

const [choferes, setChoferes] = useState([]);
//console.log(" Choferbuscar choferes",choferes)
  useEffect(() => {
    const fetchChoferes = async () => {
      try {
        const res = await fetch(`${UrlApi}/choferes`);
        const data = await res.json();
        setChoferes(data);
      } catch (error) {
        console.error("Error al traer choferes", error);
      }
    };
    fetchChoferes();
  }, []);

  return (
    <Autocomplete
      options={choferes}
      getOptionLabel={(option) =>
        option ? `${option.nombre_apellido} - DNI: ${option.dni}` : ""
      }
      value={choferes.find((c) => c.dni === value) || null}
      onChange={(e, newValue) => onChange(newValue ? newValue.dni : "")}
      renderInput={(params) => (
        <TextField {...params} label="Nombre del chofer" fullWidth />
      )}
    />
  );
}
export default Choferbuscar